export function decodeJWT(token) {
  try {
    // Split the token into parts
    if (!token) return null;
    const [header, payload, signature] = token.split('.');

    // Decode the payload (it's base64url encoded)
    const decodedPayload = JSON.parse(
      atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
    );

    // Optionally decode the header too
    const decodedHeader = JSON.parse(
      atob(header.replace(/-/g, '+').replace(/_/g, '/'))
    );

    return {
      header: decodedHeader,
      payload: decodedPayload,
      signature
    };
  } catch (error) {
    console.error('Failed to decode JWT:', error);
    return null;
  }
}
